import * as fileTypeChecker from "file-type-checker";

export namespace FileUtils {
    export enum Extension {
        TXT = "txt",
        XLSX = "xlsx",
        XLS = "xls",
        DOCX = "docx",
        PPTX = "pptx",
        CSV = "csv",
        PDF = "pdf",
        JSON = "json",
        PNG = "png",
        JPG = "jpg",
        JPEG = "jpeg",
        XML = "xml",
        HTML = "html",
        NOEXTENSION = "noextension"
    }

    export function getExtension(filename: string): Extension {
        const lastDotIndex = filename.lastIndexOf(".");
        if (lastDotIndex === -1) return Extension.NOEXTENSION;
        return filename.slice(lastDotIndex + 1).toLowerCase() as Extension;
    }

    export function getFileNameWithoutExtension(filename: string): string {
        const lastDotIndex = filename.lastIndexOf(".");
        return lastDotIndex === -1 ? filename : filename.slice(0, lastDotIndex);
    }

    export function getFileNameWithExtension(filename: string, extension: Extension): string {
        return `${filename}.${extension}`;
    }

    export async function isValidFileSignature(file: File): Promise<boolean> {
        const extension = FileUtils.getExtension(file.name);
        // Text-based files don't have binary signatures, so skip signature checking
        const textBasedFiles = ["txt", "json", "csv", "html", "xml"];
        if (textBasedFiles.includes(extension)) {
            return true;
        }

        // Binary files that support signature checking
        const fileTypesForSignatureCheck = ["jpeg", "png", "rtf", "pdf"];
        const buffer = await Promise.resolve(file.arrayBuffer());
        const fileInfo = fileTypeChecker.detectFile(buffer);

        // For binary files, verify the detected signature matches the extension
        if (!fileInfo) {
            // If no signature detected but extension requires one, it's invalid
            return !fileTypesForSignatureCheck.includes(extension);
        }

        if (!(fileInfo.extension === extension || fileInfo.signature.compatibleExtensions.includes(extension))) {
            return false;
        }

        if (fileTypesForSignatureCheck.includes(fileInfo.extension)) {
            const fileCheckerValid = fileTypeChecker.validateFileType(buffer, fileTypesForSignatureCheck);
            if (!fileCheckerValid) {
                return false;
            }
        }

        return true;
    }
}